// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__4WDgg","errors":"Errors_errors__1NDon"};